import axios from 'axios';
import { UntypedFormGroup, UntypedFormControl, Validators, FormControl } from '@angular/forms';
import { Authenticationservice } from './../../services/authentication.service';
import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import Swal from 'sweetalert2';
//import * as $ from 'jquery';
declare var $: any;

import 'datatables.net';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-askformoney68',
  templateUrl: './askformoney68.component.html',
  styleUrls: ['./askformoney68.component.css']
})
export class Askformoney68Component implements OnInit, OnDestroy {
  userdata: any;
  usercode;
  dataTable: any;
  uploadPercentage$: Observable<number>;
  valuesTomodal = [];

  e_comment1 = new UntypedFormControl(null, Validators.required);
  e_money_amt = new UntypedFormControl(null, Validators.required);
  e_docid = new UntypedFormControl(null, Validators.required);

  //@ViewChild('moneydata', { static: false }) moneydataTable: any;
  @ViewChild('moneydata') moneydataTable: ElementRef;

  constructor(
    private auth: Authenticationservice,
    private spinner: NgxSpinnerService,
    private storage: AngularFireStorage,
    private http: HttpClient) {
    this.userdata = this.auth.Authention();
    this.supzone[0] = this.userdata.zonedata;
    let supcode = this.userdata.supcode;

    if (supcode == '919' || supcode == '928') {
      this.setEdit = true;
    }
    else this.setEdit = false;
  }
  setEdit = false;
  supzone = ['', ''];

  enabled = [false, false];
  ngOnInit(): void {
    let location = window.location.hostname;
    //console.log('Running with :', location);
    if (location === 'localhost') {
      this.enabled[0] = true;
    }
    //this.getfinancebyzone();
    this.goloadfarmerinzone();
    this.loadtype_money();
  }

  ngAfterViewInit(): void {
    this.getfinancebyzone2();
  }
  tab_s = 1;

  clearFm() {
    this.txtFindIn = '';
    this.onFilterChange('');
    this.fmcode = [];
    //this.oneplant = [];
    this.dataonefarmer = [];

    this.cleartext();
  }
  year = ['2526', '6869', '68/69', '2568/2569']

  sum_money_amt = 0 //วงเงินที่ใช้ไป
  sum_money_amt1 = 0 //ขอเกี้ยว
  sum_money_amt2 = 0 //ขอเบิกปัจจัย
  sum_if_amt2 = 0 //เผื่อเบิกปัจจัย
  sum_money_temp = 0 //
  money_temp_left = 0 //


  RSUM_long = 0 //หนี้คงค้างของปี
  credit = 0 //มีวงเงิน
  limit = 0 //คงเหลือ


  ck_money_amt_last: any[];
  ck_realty_debt: any[];

  ck_money_amt_fm(fmcode: string) {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[fnc_ck_money_amt_fm${this.year[1]}]('${fmcode}')&w=1=1`;
    this.spinner.show();
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      console.log('ck_money_amt_fm:', data);
      if (data.length > 0) {
        this.ck_money_amt_last = data;
        this.sum_money_amt1 = data[0].sum_money_amt1;
        this.sum_money_amt2 = data[0].sum_money_amt2;
        this.sum_money_amt = data[0].sum_money_amt;
        this.sum_if_amt2 = data[0].if_amt2;
        this.sum_money_temp = data[0].sum_money_temp;
        this.money_temp_left = data[0].money_temp_left;

        this.ck_realty_debt = data;
        this.RSUM_long = data[0].RSUM_long + this.debt_TKS;
        this.credit = (data[0].guaranter + data[0].sumRealty);

        setTimeout(() => {
          if (this.credit > 0 || this.RSUM_long > 0)
            this.limit = (this.credit) - (data[0].sum_money_amt + data[0].RSUM_long)
        }, 100);
      } else {
        this.ck_realty_debt = [];
        this.RSUM_long = 0;
        this.credit = 0;
        this.limit = 0;

        this.sum_money_amt = 0;
        this.sum_money_amt1 = 0;
        this.sum_money_amt2 = 0;
      }

    }).catch(err => { throw (err); })
  }

  datatype_m: any[]
  subtype0: any[]
  loadtype_money() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*,left([id],1)[l_id],RIGHT([id],1)[r_id]&f=[CPS6263].[dbo].[type_money]&w=left([id],1)<>'a'";
    axios.get(url).then(res => {
      let data = res.data;
      data.sort((a, b) => { return (a.sort) - (b.sort) });
      this.datatype_m = data;
      this.subtype0 = this.datatype_m.filter((el: any) => el.r_id == '0');
    }).catch(err => { throw (err); })
  }

  // เลือกประเภทย่อย
  type_e = [0, 0, 0];
  subtype1 = [];
  typeSL = [];
  SubTypeSelectM(type0: string) {
    this.type_e = [0, 0, 0];
    let data = this.datatype_m;
    data = data.map((item: any) => {
      return { ...item, select: false };
    });
    this.typeSL[0] = type0;
    this.typeSL[1] = '';
    this.typeSL[2] = '';
    if (type0 == 'f' || type0 == 'g') {
      this.type_e[0] = 1;
      this.type_e[1] = 1;
      this.subtype1[0] = data.filter((el: any) => el.l_id == type0 && el.r_id != '0' && el.type != '1');
      this.subtype1[1] = data.filter((el: any) => el.l_id == type0 && el.r_id != '0' && el.type == '1');
    }
    else if (type0 == 'h') {
      this.type_e[0] = 2;
      this.type_e[1] = 2;
      this.subtype1[0] = data.filter((el: any) => el.l_id == type0 && el.r_id != '0');
    }
    else {
      this.type_e[0] = 2;
      this.type_e[1] = 2;
      this.subtype1[0] = data.filter((el: any) => el.l_id == type0 && el.r_id != '0');
    }
    this.typeSL[3] = type0;
    //console.log('subtype1:', this.subtype1)
  }

  SubTypeSelectS(data) {
    let landno = this.sel_landno
    if (data.l_id == 'e') {
      this.typeSL[2] = `${data.doc} ${data.value_money} บาท/ไร่`;
      landno.count = landno.balance_rent2 = (data.value_money * landno.landvalue_left).toFixed(0);
      const currentYear = new Date().getFullYear();
      this.typeSL[4] = currentYear;
      this.typeSL[5] = currentYear + parseInt(data.r_id);
    }
    else {
      this.typeSL[2] = data.doc;
    }
    this.typeSL[1] = data.id;
    //this.typeSL[3] = data.l_id;   
  }

  filterSubType() {
    let dt = this.type_e[2];
    let landno = this.sel_landno
    let data = this.subtype1[dt].filter((el: any) => el.select == true);
    this.typeSL[1] = data.map(function (elem) { return elem.id });
    this.typeSL[2] = data.map(function (elem) { return `${elem.doc} ${elem.value_money} บาท/ไร่ \n` });
    let ms = (data.reduce((sum, item) => sum + item.value_money, 0) * landno.landvalue_left).toFixed(0);
    if (landno.balance_limit < ms) {
      landno.count = landno.balance_fix = landno.balance_limit;
    }
    else {
      landno.count = landno.balance_fix = ms;
    }

    //console.log('typeSL:', this.typeSL)

  }

  // โหลดข้อมูลชาวไร่ 
  famerlist = [];

  goloadfarmerinzone() {

    let dataU = this.userdata;
    let sub = '';
    // แก้ไขพิเศษ
    if (this.setEdit == true) { sub = 'all' }
    // ผจก โซน
    else if (dataU.userlevel == 14) { sub = dataU.zonedata.substring(0, 2) }
    // ผจก ส่วน
    else if (dataU.userlevel == 15) { sub = dataU.zonedata.substring(0, 2) }

    this.loading[0] = true;
    //let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_fmcodeIn_cp${this.year[1]}?sub=` + this.userdata.zonedata;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[fnc_fmcodeIn_cp${this.year[1]}]('${sub}')&w=1=1`
    //console.log('url:', url);
    axios.get(url)
      .then(res => {
        this.loading[0] = false;
        let data = res.data.filter(el => el.set1 == 0);
        this.famerlist = data;
        this.famerlist2 = data;
        //console.log('famerlist:', date)
      }).catch(err => { throw (err); })
  }

  loading = [false, false, false, false];
  famerlist2 = [];
  onFilterChange(filterText: string): void {
    const txt = filterText.toLowerCase();
    if (txt.length > 2) {
      this.famerlist = this.famerlist2.filter(
        item =>
          item.fmcode_b1 && item.fmcode_b1.toLowerCase().includes(txt) ||
          item.fmname && item.fmname.toLowerCase().includes(txt)
      );
    }
    else this.famerlist = this.famerlist2;
  }

  // ข้อมูลแปลงของชาวไร่ 1 คน
  dataonefarmer = [];
  canget: any;
  ckfarmer = true;

  @ViewChild('farmertable', { static: false }) farmerTable: any;

  sum_arae = 0;
  lastPL = 0;
  debt_TKS = 0;
  can_withdraw = false
  fmcode: any = {};
  txtFindIn = '';
  goloaddata() {
    let fmcode = this.fmcode;//((<HTMLInputElement>document.getElementById("codefm")).value).slice(0, 10)
    console.log('fmcode:', fmcode);
    //this.LoadCreditamt(fmcode.fmcode_b1);
    //this.oneplant = []
    if ((fmcode.fmcode_b1.length) == 0) { alert('ลองกรอกรหัสชาวไร่ใหม่ หรือ คลิ๊กเลือก') }
    else {
      //this.fmcode = fmcode;      
      let sel_fm = fmcode//this.famerlist.filter((el: any) => el.fmcode_b1 == fmcode)[0];
      this.supzone[1] = sel_fm.SUPZONE;
      console.log('ckfamer', sel_fm, this.supzone);
      //console.log('ckfamer.length' ,ckfamer.length);
      this.lastPL = sel_fm.lastPercentLoan;
      this.debt_TKS = sel_fm.debt_TKS;
      //console.log('fmcode', fmcode);
      if (sel_fm == 0) { alert('ชาวไร่ไม่ได้อยู่ในโซน/ส่วนที่รับผิดชอบ') }
      else if (this.enabled[1] === false && (sel_fm.PromiseIN == 0 || sel_fm.approve == 'N')) {
        alert("ไม่สามารถเบิกได้ค่ะ");
        this.ckfarmer = true;
        this.can_withdraw = false;
        this.spinner.hide();
      }
      else if (sel_fm.zoneban == 'Y') {
        alert("ไม่สามารถทำรายการได้ เนื่องจากเป็นชาวไร่สำหรับฝ่ายกฎหมาย");
        this.ckfarmer = true;
        this.spinner.hide();
      }
      /*else if (sel_fm[0].approve == 'Y' && sel_fm[0].lastPercentLoan == 0) {
        alert("ไม่สามารถเบิกเงินได้ เนื่องจากเป็นชาวไร่ เกรด 3");
        this.ckfarmer = true;
        this.spinner.hide();
      }*/
      else {
        this.ckfarmer = false;
        this.spinner.hide();
      }
      this.loadLandno(sel_fm.fmcode_b1);
    }
  }

  loadLandno(fmcode: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cp" + this.year[1] + "_getmoney]&w=fmcode='" + fmcode + "'";
    this.dataonefarmer = [];
    this.spinner.show();
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length > 0) {
        this.dataonefarmer = (data).sort((a, b) => { return (a.intlandno) - (b.intlandno) });
        data.forEach(item => {
          this.sum_arae += item.landvalue_left;
        });
        console.log('sum_arae:', this.sum_arae);
        console.log('sum_if_amt2:', this.sum_if_amt2);
        console.log('sum_arae*sum_if_amt2:', this.sum_arae * this.sum_if_amt2);
        this.ck_money_amt_fm(fmcode);
        //this.loadfactor_fm(sel_fm.fmcode_b1);
      }
    }).catch(err => { throw (err); })
  }

  crdamt = [];
  LoadCreditamt(fmcode: any) {
    this.spinner.show();
    let url2 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[cps6263].[dbo].[v_sum_money_amt]&w=[YearID]='" + this.year[1] + "'and[fmcode]='" + fmcode + "'";
    this.canget = null;
    axios.get(url2).then(res => {
      this.spinner.hide();
      if (res.data.length > 0) this.crdamt = res.data;
      else this.crdamt = [];
    }).catch(err => { console.log(err); })
  }

  filteredList = [];
  filterList(query: string) {
    this.filteredList = this.famerlist.filter(item =>
      item.fmname.includes(query) || item.fmcode_b1.includes(query)
    );
  }

  forwardcredit: any;
  checkcredit: any;
  sel_landno: any = {};

  snaponedata(sdata: any, sty = 1) {//** เลือกแปลง  */
    this.subtype1 = [];
    this.typeSL = ['', '', '', ''];
    sdata.comment = '', sdata.count = 0, sdata.balance_rent2 = 0, sdata.balance_fix = 0, sdata.typeD = sty;
    let data = sdata;
    //  return { ...item, comment: '', count: 0, typeD: 0 };
    this.sel_landno = data;
    if (sty == 1) {
      $("#plantnum").val(data.intlandno + ', ประเภทอ้อย: ' + data.CaneTypeName + ', พื้นที่: ' + data.landvalue_left.toLocaleString() + ' ไร่');
      //this.form_money.docid = data.docid;
    }
    else if (sty == 2) {
      $("#plantnum").val(data.intlandno + ', ประเภทอ้อย: ' + data.canename + ', พื้นที่: ' + data.landvalue_left.toLocaleString() + ' ไร่');
    }
    console.log(', sel_landno', this.sel_landno);

    //this.form_money.fmcode = data.fmcode;
    if (data.length == 0 || data == null) {
      this.checkcredit = [{ 'cdam': parseInt(data.credit_amount), 'sma': 0 }];
    }
    else {
      this.checkcredit = [{ 'cdam': parseInt(data.credit_amount), 'sma': parseInt(data.sum_money_amt) }];
    }

    //document.getElementById("fmnamelable").innerHTML = data.fmname;
    //$("#fmnamelable").val(data.fmname)
    // $("#fmname").val(data[0].fmname);
    //console.log('form_money', this.form_money);
  }

  // บันทึกข้อมูล
  async gosave(d = 1) {
    let data = this.sel_landno;
    let fmcode = data.fmcode;
    let cmdcheck = parseInt(this.checkcredit[0].cdam) - parseInt(this.checkcredit[0].sma);

    let comemnt = data.comment;
    let conut: number = data.count;
    //let balance_rent = this.sel_landno.balance_rent;
    let firebaseid = data.firebaseid
    let typeSL = this.typeSL;
    let type_m = typeSL[1];
    let type_m1 = typeSL[3];
    let over_limit = "0";
    let doc_status = "0";
    let supzoneS = '';
    console.log('sel_landno', data, typeSL)
    if (this.setEdit) supzoneS = this.supzone[1];
    else supzoneS = this.supzone[0];

    //console.log('fmcode',fmcode,'cmdcheck',cmdcheck,'conut',conut,'type_m',type_m,'substring type_m',type_m.substring(1,1),'conut',conut ,'cmdcheck',cmdcheck)
    //let type_money:string = null
    // กรณีเกินวงเงินแปลงนั้นๆ

    // สำหรับการขอจาก ผจก.ที่เกินวงเงิน
    // if (conut > this.checkcredit.cdam) { over_limit = "1" }
    // { alert("จำนวนเงินเกินวงเงิน กรุณาลองใหม่");}
    //  if ( conut  > cmdcheck && this.userdata.userlevel != '15') {
    //     alert("จำนวนเงินเกินวงเงิน กรุณาลองใหม่");
    //   }

    if (this.can_withdraw = false) { alert("ไม่สามารถบันทึกข้อมูลได้"); }
    else if (fmcode == null || fmcode == '') { alert("กรุณาระบุชาวไร่"); }
    else if (type_m == null || type_m == '') { alert("กรุณาเลือกประเภทเกี้ยว"); }
    else if (comemnt == null || comemnt == '') { alert("กรุณาระบุคำอธิบาย"); }
    else if (conut <= 0 || conut == null || conut == 0) { alert("กรุณาระบุจำนวนเงินที่มากกว่า 0"); }
    else if (type_m1 == 'e' && conut > data.balance_rent) { alert(`${typeSL[2]} ขอได้ไม่เกิน ${data.balance_rent.toLocaleString()}`); }

    else if (type_m1 == 'e' && this.files_d == null) { alert(`กรุณาเลือกไฟล์ค่าเช่าก่อน`); }

    else if ((type_m1 == 'a' || type_m1 == 'f' || type_m1 == 'g') && conut > cmdcheck) { alert("เงินส่งเสริมระยะสั้น ไม่สามารถเกินวงเงินรายแปลงได้"); }
    else if ((type_m1 == 'f' || type_m1 == 'g') && conut > data.balance_fix) { alert(`${typeSL[2]} ขอได้ไม่เกิน ${data.balance_fix.toLocaleString()}`); }
    else if (type_m1 == 'h' && conut > this.money_temp_left) { alert(`วงเงินชั่วคราวขอได้ไม่เกิน ${this.money_temp_left}`); }
    else if (type_m1 != 'e' && type_m1 != 'h' && conut > this.limit) { alert("ไม่สามารถบันทึกข้อมูลได้ เนื่องจากเบิกเกินหลักทรัพย์ค้ำประกัน"); }
    else {
      let textconfirm = `ยืนยันการบันทึก ${typeSL[2]}\nหมายเหตุ ${comemnt} \nจำนวนเงิน ${conut.toLocaleString()} บาท`;
      if ((type_m1 == 'a' || type_m1 == 'f' || type_m1 == 'g') && type_m1 != 'e' && conut > cmdcheck) { over_limit = "1"; doc_status = "2" }
      //if (conut > this.limit) { textconfirm = "เนื่องจากยอดรวม " + conut + " เกินวงเงินคงเหลือ " + this.limit + " ต้องการการบันทึกข้อมูล" }
      console.log('over_limit:', over_limit, 'zone:', supzoneS, 'conut :', conut, ' | cmdcheck:', cmdcheck)

      if (confirm(textconfirm)) {
        let url = ''
        if (d == 1) {
          url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insert_getfactorw?YearID='${this.year[1]}'&supcode='${this.userdata.supcode}'
            &Zone_ID='${supzoneS}'&factor_type='1'&itid='${data.itid}'&intlandno='${data.intlandno}'&fmcode='${data.fmcode}'&comment1='${data.comment}'&money_amt=${conut}
            &img_url='${this.geturlcontact}'&over_limit='${over_limit}'&doc_status='${doc_status}'&type_money='${type_m}'`;
        }
        else if (d == 2) {
          url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=${firebaseid}&doc_status='${doc_status}'
          ,over_limit='${over_limit}',money_amt=${conut},comment1='${data.comment}',type_money='${type_m}'`
        }
        url = url.replace(/\n\s*/g, '\n');
        axios.post(url).then(async res => {
          if (res.data.rowsAffected[0] >= 1) {
            alert("บันทึกข้อมูลเรียบร้อยแล้วค่ะ");
            if (d == 1 && type_m1 == 'e') {
              let data = res.data.recordset[0];
              console.log(data.docid, data)
              this.sel_landno.docid = data.docid;
              let data2 = this.sel_landno
              await this.toUpload(data2);
            }
            //this.askformoney.reset();
            this.geturlcontact = '';
            this.url_load = '';
            setTimeout(() => {
              this.ck_money_amt_fm(fmcode);
              this.loadLandno(fmcode);
              this.getfinancebyzone();
            }, 100);
            this.cleartext();
          }
          else { alert("!!!! บันทึกข้อมูลไม่สำเร็จ !!!!"); }
        }).catch(err => { throw (err); })
      }
      else {
        {
          /*alert(" !! ยกเลิกบันทึกข้อมูลเรียบร้อยแล้วค่ะ !!");
          this.askformoney.reset();*/
        }
      }
    }
  }

  geturlcontact = '';
  url_load = ''
  files_d: any;
  maxSize = 30 * 1024 * 1024; // 10 MB (adjust as needed)
  async onFileSelected(event: any) {
    var files = event.target.files[0];
    console.log(files);

    if (this.year[1].length == 0) {
      alert('กรุณาเลือกปี ');
      this.url_load = '';
    }
    /*else if (files.type != 'application/pdf') {
      alert('กรุณาเลือกไฟล์ที่เป็น PDF เท่านั้น');
      this.url_load = '';
    }*/
    else if (files.size > this.maxSize) {
      alert('ไฟล์ที่จะอัพโหลด ขนาดไฟล์ต้องไม่เกิน 30 MB');
      this.url_load = '';
    }
    else {
      //const file = files[0]; // get single file  
      this.files_d = files;
      console.log('files_up');
    }
  }

  async toUpload(data) {
    //let sel_land = data;
    var files = this.files_d
    const file = files[0];    // get single file      
    const name = files.name;
    /*const Date_dt = new Date();
    const timestamp = Date_dt.getTime();
    console.log('timestamp:', timestamp);*/
    const randomstr = Array(4).fill(0).map(() => Math.random().toString(36)[2]).join('');
    const path = `rentalfiles/${data.fmcode}/${this.year[1]}_${data.intlandno}_${randomstr}_${name}`;
    const ref = this.storage.ref(path);
    const task = this.storage.upload(path, files);
    // เริ่มอัพโหลด ให้กำหนด isUploading เป็น true
    this.loading[1] = true;
    this.storage
      .upload(path, file).percentageChanges();
    task.snapshotChanges().pipe(
      finalize(() => {
        /*ref.getDownloadURL()
          .toPromise()
          .then(async (url) => {
            //console.log('url:', url);
            let newUrl = url.split('&token')[0];
            console.log('newUrl:', newUrl);
            this.url_load = newUrl;
            // เมื่ออัพโหลดเสร็จสิ้นหรือเกิดข้อผิดพลาด ให้กำหนด isUploading เป็น false
            this.isUploading = false;
            await this.insert_rentalfile(data);
          });*/
        const publicUrl = `https://storage.googleapis.com/brr-farmluck.appspot.com/${path}`;
        console.log('Public URL:', publicUrl);
        //this.url_load = publicUrl; // สร้าง Public URL เองจาก bucket และ path
        this.loading[1] = false;
        this.insert_rentalfile(data, publicUrl);
      })
    ).subscribe();
  }

  async insert_rentalfile(data, url0: string) {
    //let data = this.sel_landno;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?t=[dbintechgen3].[dbo].[rentalfile]&c=`
      + `[user_id],[area_id],[doc_ref],[doc_url],[year_start],[year_end],[remark],[created_at],[updated_at]&v=`
      + `'${data.supervisor_id}','${data.areasID}','${data.docid}','${url0}',${this.typeSL[4]},${this.typeSL[5]},'${data.comment}',getdate(),getdate()`;
    //console.log('test_url_insert:', url);
    axios.get(url).then(res => {
      if (res.data.rowsAffected[0] >= 1) {
        this.files_d = null;
      }
      else {
        alert("!!!! อัพโหลดไฟล์ ไม่สำเร็จ !!!!");
      }
    }).catch(err => { throw (err); })
  }

  // clear ช่อง
  cleartext() {
    this.geturlcontact = '';
    //this.dataonefarmer = []
    this.sel_landno = {};
    //this.form_money = { firebaseid: '', docid: '', itid: '', intlandno: '', fmcode: '', comment: '', count: 0, typeD: 0 };
    $("#plantnum").val('');

  }

  // โหลดข้อมูลสินเชื่อ
  datafinance = [];
  newtable: any
  getfinancebyzone() {
    if (this.newtable != undefined || this.newtable != null) {
      this.newtable.destroy();
    }
    let supzoneA = this.userdata.zonedata;
    let dtop = '';

    let url2 = ''
    // console.log('userdata zonedata:' ,this.userdata.zonedata);
    if (this.setEdit) {
      dtop = 'top 100 *';
      url2 = `&w=1=1 order by[docid]desc`;
    }
    else if (this.userdata.userlevel == 15) {
      dtop = '*';
      url2 = `&w=[partcode]='${supzoneA}'&[over_limit]=1`;
    }
    else {
      dtop = 'top 200 *';
      url2 = `&w=[zonePost]='${supzoneA}'`;
    }
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=${dtop}&f=[CPS6263].[dbo].[v_getfinance${this.year[1]}]${url2}`

    this.loading[1] = true;
    axios.get(url).then(res => {
      this.loading[1] = false;
      if (res.data.length > 0) {
        this.datafinance = [];
        let data = res.data;
        setTimeout(() => {
          this.datafinance = data;
          setTimeout(() => {
            this.newtable = $(this.moneydataTable.nativeElement).DataTable({ order: [[0, 'desc']] });
          }, 300);
        }, 400);
      } else {
        this.datafinance = [];
      }
    }).catch(err => { throw (err) });
  }
  table1: any;
  getfinancebyzone2(): void {
    let supzoneA = this.userdata.zonedata;
    let url2 = ''
    // console.log('userdata zonedata:' ,this.userdata.zonedata);
    if (this.setEdit) {
      url2 = `&w=1=1 order by[docid]desc`;
    }
    else if (this.userdata.userlevel == 15) {
      url2 = `partcode='${supzoneA}'&[over_limit]=1`;
    }
    else {
      url2 = `zonePost='${supzoneA}'`;
    }
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/function-3/datatable_w';// เปลี่ยนเป็น URL ของ Cloud Function
    let dataTable = {
      table: `[dbo].[v_getfinance${this.year[1]}]`
      , col_like: 'fmcode,fmname'
      , where: url2
    }
    let self = this; // ใช้ self เพื่อให้สามารถเรียก method ภายใน class ได้
    if (this.table1) {
      this.table1.destroy(); // ทำลายตารางเก่า ถ้ามี
    }
    this.table1 = $('#datatable').DataTable({
      processing: true,
      serverSide: true,
      paging: true, // ✅ เปิดใช้งาน Pagination
      searching: true, // ✅ เปิดใช้งาน Search
      ordering: true, // ✅ เปิดใช้งาน Sorting
      order: [[1, "desc"]],
      //lengthMenu: [5, 10, 25, 50], // ✅ ตั้งค่าจำนวนรายการต่อหน้า
      ajax: (data, callback) => {
        $('#loadingIndicator').show(); // แสดงตัวโหลดก่อนเรียก API
        const params = {
          table: dataTable.table,
          col_like: dataTable.col_like,
          where: dataTable.where,
          start: (data as any).start,
          length: (data as any).length,
          search: (data as any).search.value,
          orderColumn: (data as any).columns[(data as any).order[0].column].data,
          orderDir: (data as any).order[0].dir,
          draw: (data as any).draw
        };

        this.http.get(url, { params }).subscribe((resp: any) => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
          $('#loadingIndicator').hide(); // ซ่อนตัวโหลดหลังจากโหลดเสร็จ
        }, () => {
          $('#loadingIndicator').hide(); // ซ่อนตัวโหลดในกรณีเกิดข้อผิดพลาด
        });
      },
      columns: [
        { data: 'docid', title: 'เลขคำขอ' },
        {
          data: 'datepost', title: 'วันที่ขอ', className: 'text-left',
         // render: (data: any) => { return this.date2th(data) }
        },
        { data: 'fmname', title: 'ชื่อ', className: 'text-left' },
        { data: 'intlandno', title: 'แปลง' },
        { data: 'type_money_sub', title: 'ประเภทเกี้ยว' },
        { data: 'comment1', title: 'เหตุผล' },
        {
          data: 'money_amt', title: 'จำนวนขอ',
          render: (data: any) => { return this.formatNumber(data, 0, 0) }, className: 'text-right'
        },
        {
          data: 'credit_approved', title: 'จำนวนอนุมัติ',
          render: (data: any) => { return this.formatNumber(data, 0, 0) }, className: 'text-right'
        },
        { data: 'docdesc', title: 'สถานะ' },
        {
          data: null, title: 'Actions',
          orderable: false,
          render: function (data: any, type: any, row: any) {
            /*return `<button class="btn btn-primary btn-sm action-btn" data-row='${JSON.stringify(row)}'>เลือก</button>
            `;*/
            let buttons = '';
            // ปุ่ม "อนุมัติ" เมื่อ approveSts = 1
            if (row.doc_status == 2 && this.userdata.userlevel == '15') {
              buttons += `<button class="btn btn-success btn-sm action-approve" data-row='${JSON.stringify(row)}'>ส่งต่อสินเชื่อ</button> `;
            }
            // ปุ่ม "ยกเลิก" เมื่อ approveSts = 2
            if (row.doc_status == 2 || row.doc_status == 0) {
              buttons += `<button class="btn btn-danger btn-sm action-cancel" data-row='${JSON.stringify(row)}'>ยกเลิก</button> `;
            }
            return buttons;
          }
        }
      ]
    });
    // เพิ่ม Event ตรวจจับการพิมพ์ในช่อง Search
    /*$('#datatable_filter input')
    .off()
    .on('keyup', function () {
      let searchText: string = String($(this).val()); // บังคับเป็น string
      if (searchText.length > 2) {
        self.dataTable.search(searchText).draw(); // ค้นหาเมื่อมากกว่า 2 ตัวอักษร
      } else {
        self.dataTable.search('').draw(); // รีเซ็ตผลลัพธ์ถ้าพิมพ์น้อยกว่า 2 ตัวอักษร
      }
    });*/
    $('#datatable tbody').on('click', '.action-approve', function () {
      let rowData = JSON.parse($(this).attr('data-row'));
      self.forwardtoFN(rowData);
    });
    // กดปุ่ม "ยกเลิก"
    $('#datatable tbody').on('click', '.action-cancel', function () {
      let rowData = JSON.parse($(this).attr('data-row'));
      self.cancledoc_id(rowData);
    });
  }
  // Method ที่ใช้รับค่าจากปุ่ม
  onButtonClick(rowData: any) {
    console.log('ข้อมูลที่ถูกเลือก:', rowData);
    // ทำงานเพิ่มเติมที่นี่ เช่น เรียก API หรือไปยังหน้าอื่น
  }
  formatNumber(value: number, a: number, b: number): string {
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: a, maximumFractionDigits: b }).format(value);
  }


  fm_factor = [];
  loadfactor_fm(fmcode: string) {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance${this.year[1]}]&w=[fmcode]='${fmcode}'and[doc_status]='F'`;
    axios.get(url)
      .then(res => {
        this.fm_factor = res.data;

        //console.log('famerlist',this.famerlist)
      }).catch(err => { throw (err); })
  }

  ngOnDestroy() {
    this.forwardcredit = null;
    this.dataonefarmer = null;
    this.userdata = null;
    this.usercode = null;
    this.geturlcontact = null;
    this.datafinance = [];
  }

  // ส่งข้อมูลไปพิมพ์
  getfmcode(fmcode) {
    localStorage.setItem('fmcodedataforaskmoney', JSON.stringify(fmcode).toString());
  }

  // ต้องการยกเลิกรายการ
  cancledoc_id(data) {
    //console.log('data-cancledoc_id:', data);
    Swal.fire({
      title: `ยืนยัน ยกเลิกเกี้ยว ${data.docid} รายการนี้?`,
      // text: 'You will not be able to recover this file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
    }).then((result) => {
      if (result.value) {
        let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=" + data.firebaseid + "&doc_status='X'";
        //console.log('url-cancledoc_id:', url);
        axios.post(url).then(res => {
          if (res.data.rowsAffected == 1) {
            this.datafinance.filter(el => el.docid != data.docid);
            Swal.fire('ยกเลิกรายการเกี้ยวสำเร็จ!', '', 'success')
            setTimeout(() => {
              if (this.newtable != undefined || this.newtable != null) {
                this.newtable.destroy();
              }
              this.newtable = $(this.moneydataTable.nativeElement).DataTable({ order: [[0, 'desc']] });
            }, 200);
            this.loadLandno(data.fmcode);
            this.getfinancebyzone2();
            //this.loadfactor_fm(data.fmcode);
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'เกิดความผิดพลาดในการยกเลิกเกี้ยว!',
              footer: '<a href="">กรุณาลองใหม่อีกครั้ง หากยังพบปัญหา ให้ติดต่อ itBRD?</a>'
            })
          }
        })
      }
    })
  }

  // ส่งรายการให้ฝ่ายสินเชื่อ
  forwardtoFN(doc: any) {
    $("#forwardtofn").modal('show');
    this.valuesTomodal = [doc.docid, doc.money_amt, doc.comment1, doc.fmname, doc.datepost];
    // console.log('value to modal is ',this.valuesTomodal);
  };

  // บันทึกข้อมูลของ หัวหน้าส่วน ไปยังฝ่ายสินเชื่อ
  saveforwardtoFN(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_getfactor?docid=" + f.e_docid
      + "&comment1=" + f.e_comment1 + "&money_amt=" + f.e_money_amt + "&doc_status=0";
    //console.log('url: ',url);
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      // text: 'You will not be able to recover this file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        axios.post(url).then(res => {
          if (res.data.rowsAffected == 1) {
            Swal.fire('Saved!', '', 'success')
            this.getfinancebyzone();
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'เกิดความผิดพลาดในการอัพเดตข้อมูล!',
              footer: '<a href="">กรุณาลองใหม่อีกครั้ง หากยังพบปัญหา ให้ติดต่อ itBRD?</a>'
            })
          }
        })
      } else if (result.dismiss == Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          // 'Your imaginary file is safe :)',
          'cancle'
        )
      }
    })
  };

  // ส่งรายการให้ฝ่ายสินเชื่อ
  forwardtoFNX(data) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=" + data.firebaseid + "&doc_status=0";
    if (confirm("ยืนยันส่งรายการไปยังฝ่ายสินเชื่อ ?") == true) {
      console.log('url-cancledoc_id:', url);
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected[0] == 1) { alert("ส่งรายการไปยังฝ่ายสินเชื่อแล้ว"); this.getfinancebyzone(); }
          else {
            alert("!!! เกิดข้อผิดพลาดในการส่งรายการไปยังฝ่ายสินเชื่อ กรุณาลองใหม่ !!!")
          }
        }).catch(err => { throw (err); })

    } else {
      return false;
    }
  };

  date2th(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

}
